export default "__VITE_ASSET__CogiZ5CA__"